import './Pricing.css';
import Header from "../Home/Header";
import PricingCard1 from '../../Images/PricingCard1.png';
import PricingCard2 from '../../Images/PricingCard2.png';
import PricingCard3 from '../../Images/PricingCard3.png';
import React from 'react';

export default class Pricing extends React.Component {
    componentDidMount() {
		document.title = "Pricing | CSCult's Gamified CP";
	}
    
    render() {

        return (
            <main>
                <Header />
                <div className="pricing-container">
                    <h1>Pricing</h1>
                    <p>Before purchasing a bundle, you MUST sign up first on the GCP Platform. All bundle prices are set for annual usage.</p>
                    <div className="pricing-cards">
                        <div className="pricing-card">
                            <img src={PricingCard1} />
                            <button id="btn-1">PURCHASE</button>
                        </div>
                        <div className="pricing-card">
                            <img src={PricingCard2} />
                            <button id="btn-2">PURCHASE</button>
                        </div>
                        <div className="pricing-card">
                            <img src={PricingCard3} />
                            <button id="btn-3">PURCHASE</button>
                        </div>
                    </div>
                </div>
            </main>
        );
    }
}